import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kMNotation'
})
export class KMNotationPipe implements PipeTransform {
  transform(value: string): string {
    const numValue = Number(value);
    let output: string = (Number.isInteger(numValue)?numValue: numValue.toFixed(1)).toString();

    // If the value isn't a valid number, return it unchanged
    if (isNaN(numValue)) {
      return value;
    }

    const isNegative = numValue < 0;
    const absValue = Math.abs(numValue);

    const billion = 1_000_000_000;
    const million = 1_000_000;
    const thousand = 1_000;

    if (absValue >= billion) {
      const formatted = absValue / billion;
      const finalValue = formatted % 1 === 0 ? formatted : formatted.toFixed(1).replace(/\.0$/, '');
      output = `${isNegative ? '-' : ''}${finalValue}B`;
    } else if (absValue >= million) {
      const formatted = absValue / million;
      const finalValue = formatted % 1 === 0 ? formatted : formatted.toFixed(1).replace(/\.0$/, '');
      output = `${isNegative ? '-' : ''}${finalValue}M`;
    } else if (absValue >= thousand) {
      const formatted = absValue / thousand;
      const finalValue = formatted % 1 === 0 ? formatted : formatted.toFixed(1).replace(/\.0$/, '');
      output = `${isNegative ? '-' : ''}${finalValue}K`;
    }

    return output;
  }
}
